import React, { FC } from 'react';

import { useUnit } from 'effector-react';

import * as Collapsible from '@radix-ui/react-collapsible';
import clsx from 'clsx';

import { $isTelegramPromoVisible, $isTelegramPromoVisibleApi } from '@stores/telegram-promo';

import { Button } from '@components/common/Button/Button';
import { Container } from '@components/common/Container/Container';
import { ChevronRightIcon, CloseIcon, TelegramIcon } from '@components/icons';

import styles from './TelegramPromo.module.scss';

export const TelegramPromo: FC = () => {
    const [state, handleClose] = useUnit([
        $isTelegramPromoVisible,
        $isTelegramPromoVisibleApi.close,
    ]);
    const { isOpen } = state;

    return (
        <Collapsible.Root open={isOpen} onOpenChange={handleClose} asChild>
            <Collapsible.Content className={styles.collapsibleContent}>
                <div className={styles.root}>
                    <TelegramIcon className={styles.backgroundIcon} aria-hidden />
                    <Container>
                        <div className={styles.content}>
                            <span className={styles.title}>
                                Все самые интересные новости и&nbsp;предложения на&nbsp;нашем
                                Telegram-канале!
                            </span>
                            <Button
                                variant="white"
                                link="https://t.me/gurman_m_vl"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={clsx(styles.button, styles.subscribe)}
                                classes={{ content: styles.buttonContent }}
                                onClick={handleClose}
                            >
                                Подписаться
                                <ChevronRightIcon />
                            </Button>
                            <button
                                type="button"
                                className={clsx(styles.button, styles.close)}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                    </Container>
                </div>
            </Collapsible.Content>
        </Collapsible.Root>
    );
};
